import React from "react";

const Japan = () => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 20 15"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        height="15"
        id="mask0_305_22442"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
        width="20"
        x="0"
        y="0"
      >
        <rect fill="white" height="15" width="20" />
      </mask>
      <g mask="url(#mask0_305_22442)">
        <path
          clipRule="evenodd"
          d="M0 0V15H20V0H0Z"
          fill="#F7FCFF"
          fillRule="evenodd"
        />
        <mask
          height="15"
          id="mask1_305_22442"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
          width="20"
          x="0"
          y="0"
        >
          <path
            clipRule="evenodd"
            d="M0 0V15H20V0H0Z"
            fill="white"
            fillRule="evenodd"
          />
        </mask>
        <g mask="url(#mask1_305_22442)">
          <path
            clipRule="evenodd"
            d="M10 12.1875C12.5888 12.1875 14.6875 10.0888 14.6875 7.5C14.6875 4.91117 12.5888 2.8125 10 2.8125C7.41117 2.8125 5.3125 4.91117 5.3125 7.5C5.3125 10.0888 7.41117 12.1875 10 12.1875Z"
            fill="#E31D1C"
            fillRule="evenodd"
          />
        </g>
      </g>
      <rect height="14" rx="1" stroke="#E8E7E4" width="19" x="0.5" y="0.5" />
    </svg>
  );
};

export default Japan;
